<template>
  <div>
    <FilterQuick
      padding="!p-0"
      default-value="popular"
      :options="[
        { label: $t('pages.index.filters.popular'), icon: 'cute/popular', active: '!bg-ruby-100 !text-ruby-950 dark:!bg-ruby-950 dark:!text-ruby-100', value: 'popular' },
        { label: $t('pages.index.filters.new'), icon: 'cute/new', active: '!bg-royal-200 !text-royal-950 dark:!bg-royal-950 dark:!text-royal-100', value: 'recent' },
      ]"
      v-model="quickFilter"
    />

    <div class="mt-3 space-y-2">
      <PostContainer
        :post="comment"
        type="comment"
        :parent="post"
        :is-display-comments="true"
        :can-reply="true"
        v-for="comment in posts"
        @answer="(postId, isComment) => emit('answer', postId, isComment)"
        :key="comment._id"
      />
      
      <SkeletonBase class="!bg-whale-950/5 h-24 rounded-3xl dark:!bg-dark-900" is-animated v-for="i in 12" :key="i" v-if="isPending" />

      <div class="rounded-b-3xl sm:rounded-3xl text-center pt-2 pb-4 px-6 bg-gradient-to-t from-whale-500/10 to-whale-100/0 text-whale-950 dark:text-dark-100 col-span-2 h-full" v-if="!isPending && posts.length === 0" key="empty-event-2">
        <ImageEmoji name="Eyes" class="size-8 mx-auto" />
        <p class="font-bold text-lg mb-1.5 mt-2 leading-tight">{{ $t('components.Feed.empty.title') }}</p>
        <p class="text-base max-w-sm mx-auto">{{ $t('components.Feed.empty.content') }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { postCommentsGetAPI } from '~/api/post'
import { Post } from '~/classes'
import UsersStore from '~/store/users'
import PostsStore from '~/store/posts'

const props = withDefaults(defineProps<{
  post: Post
}>(), {

})

const quickFilter: Ref<'popular' | 'recent'> = ref('popular')

const usersStore = UsersStore()
const postsStore = PostsStore()

const isEnd = ref(false)

const emit = defineEmits<{
  (e: 'answer', postId: string, isComment: boolean): void
}>()

const postIds: Ref<string[]> = ref([])
const posts = computed(() => postsStore.getItems(postIds.value))
const page = ref(0)

const isPending = ref(true)

const { refresh } = useLazyAsyncData(async () => {
  try {
    if (isEnd.value) return

    isPending.value = true
    if (page.value === 0) postIds.value = []

    const response = await postCommentsGetAPI(props.post._id, {
      sort: quickFilter.value === 'popular' ? { popularity: -1 } : { createdAt: -1 },
      per_page: 12,
      page: page.value
    })

    if (response.ok) {
      response.data.users.forEach(u => usersStore.setItem(u))
      response.data.posts.forEach(p => postsStore.setItem(p))
      postIds.value = [
        ...postIds.value,
        ...response.data.posts.map(p => p._id)
      ]

      if (response.data.posts.length < 12) {
        isEnd.value = true
      }
    }
  } catch (e) {
    console.log(e)
  }

  isPending.value = false
}, {
  immediate: false
})

watch(quickFilter, () => {
  page.value = 0
  isEnd.value = false
  refresh()
}, { immediate: true }) 

defineExpose({
  refresh: () => {
    page.value = 0
    isEnd.value = false
    refresh()
  },
  next: () => {
    page.value += 1
    refresh()
  }
})
</script>